import { Box } from "@mui/material";
import MetaTags from "react-meta-tags";

import { MoreQuestions } from "components/MoreQuestions";
import {
  TECHNOLOGY_PLATFORM_TITLE,
  TECHNOLOGY_PLATFORM_LINK_CANONICAL,
} from "helpers/metatags";

import { DetailInfo } from "./components/DetailInfo";
import { OnePlatform } from "./components/OnePlatform";
import { SimpleWorkflow } from "./components/SimpleWorkflow";
import { TopBanner } from "./components/TopBanner";
import { Visit } from "./components/Visit";

export const TechnologyPlatform = () => (
  <Box component="article" width={1}>
    <MetaTags>
      <title>{TECHNOLOGY_PLATFORM_TITLE}</title>
      <link rel="canonical" href={TECHNOLOGY_PLATFORM_LINK_CANONICAL} />
    </MetaTags>

    <TopBanner />
    <DetailInfo />
    <SimpleWorkflow />
    <OnePlatform />
    <Visit />
    <MoreQuestions />
  </Box>
);
